import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnon = process.env.REACT_APP_SUPABASE_ANON_KEY;

const isConfigured = !!(supabaseUrl && supabaseAnon);

if (!isConfigured) {
  console.warn('[GrindLog] Supabase not configured — running offline (localStorage only).');
}

// Exportamos el cliente solo si está configurado, sino un objeto dummy
// para que la app no rompa en desarrollo sin .env
export const supabase = isConfigured
  ? createClient(supabaseUrl!, supabaseAnon!, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
      },
    })
  : null as any;

export const SUPABASE_ENABLED = isConfigured;

export type SupabaseSession = any;
